/**
 * Errores tipados del dominio. Permiten manejo granular en UI
 * y logging estructurado sin acoplar a códigos de Firebase.
 */
export class AppError extends Error {
  constructor(message, code, cause) {
    super(message);
    this.name = 'AppError';
    this.code = code;
    this.cause = cause;
  }
}

export class AuthError extends AppError {
  constructor(message, cause) {
    super(message, 'AUTH_ERROR', cause);
    this.name = 'AuthError';
  }
}

export class FirestoreError extends AppError {
  constructor(message, cause) {
    super(message, 'FIRESTORE_ERROR', cause);
    this.name = 'FirestoreError';
  }
}

export class StorageError extends AppError {
  constructor(message, cause) {
    super(message, 'STORAGE_ERROR', cause);
    this.name = 'StorageError';
  }
}

/**
 * Mapea códigos crudos de Firebase a mensajes user-friendly.
 */
export const mapFirebaseAuthError = (firebaseError) => {
  const codeMap = {
    'auth/popup-closed-by-user': 'Cancelaste el inicio de sesión.',
    'auth/popup-blocked': 'El navegador bloqueó la ventana emergente.',
    'auth/network-request-failed': 'Sin conexión. Revisá tu red.',
    'auth/too-many-requests': 'Demasiados intentos. Probá más tarde.',
    'auth/user-disabled': 'Esta cuenta fue deshabilitada.',
  };
  return codeMap[firebaseError?.code] || 'Error de autenticación inesperado.';
};